module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.isAdv) ? _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top ys-icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "hz-main"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cus"
  }, [_c('h2', [_vm._v("客户服务")]), _vm._v(" "), _c('p', [_vm._v("客服热线：4000666122(工作日9:00-18:00)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "qrcode-main"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("Copyright © 169 2017 - 2018 Diandian 点点版权所有 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备17079095号")]), _vm._v(" 深圳众联商务有限公司")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4fed49"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footerMobile/index.vue
// module id = 343
// module chunks = 1